// ABOUTME: User "Environments" page; hosts the main-environment (default login landing) setting.
// ABOUTME: Mirrors the account General page shell so both user pages look identical.

import { Box, useTheme } from "@mui/material";
import { forwardRef, useImperativeHandle } from "react";
import { useSelector } from "react-redux";
import Subheading from "../../../components/theme/text/Subheading";
import Text from "../../../components/theme/text/Text";
import Icon from "../../../components/theme/icons/Icon";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import TabView3 from "../../../components/theme/TabView3/TabView3";
import { selectUser } from "../../../newapi/user/authentication/authSlice";
import { tokens } from "../../../theme";
import { userEnvironmentsConfig } from "./userEnvironmentsConfig";
import MainEnvironment from "./views/MainEnvironment";

const UserEnvironments = forwardRef((props, ref) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const user = useSelector(selectUser);

    useImperativeHandle(ref, () => ({
    }));

    return (
        <Box
            sx={{
                width: 1,
                paddingTop: 9,
                position: "relative",
                "@media screen and (max-width: 47.9375em)": {
                    paddingX: 0,
                    paddingTop: 1,
                    background: colors.bg["tertiary"],
                    "&:before,&:after": {
                        display: "none",
                    },
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: 1,
                    paddingX: 4,
                    pt: 2,
                    pb: 3,
                    background: colors.bg["tertiary"],
                    "@media screen and (max-width: 47.9375em)": {
                        pt: 0,
                        pl: 3,
                        pr: 0,
                    },
                }}
            >
                <Box
                    sx={{
                        height: 48,
                        display: "flex",
                        alignItems: "center",
                        boxShadow: " 0px 1px 2px 0px rgba(49, 65, 95, 0.25)",
                        pl: 0.5,
                        pr: 3,
                        background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        borderRadius: 6,
                        "@media screen and (max-width: 47.9375em)": {
                            background: "unset",
                            pl: 0,
                            boxShadow: "none",
                            pr: 0,
                        },
                    }}
                >
                    <Icon rounded theme="pink"> <ApartmentOutlinedIcon/> </Icon>
                    <Box
                        sx={{
                            ml: 2,
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            "@media screen and (max-width: 47.9375em)": {
                                flexDirection: "column",
                                gap: 0,
                                alignItems: "flex-start",
                            },
                        }}
                    >
                        <Subheading>{user?.name}</Subheading>
                        <Text>{user?.email}</Text>
                    </Box>
                </Box>
            </Box>

            <TabView3
                tabConfig={userEnvironmentsConfig}
                sx={{
                    minHeight: "calc(100%)",
                    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    position: "relative",
                    zIndex: 2,
                    height: 1,
                    display: "flex",
                    flexDirection: "column",
                    "&:before": {
                        content: "''",
                        display: "block",
                        width: "32px",
                        height: "48px",
                        position: "absolute",
                        left: 0,
                        top: "40px",
                        zIndex: 1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        borderTopLeftRadius: "24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transition: "250ms",
                    },
                    "&:after": {
                        content: "''",
                        display: "block",
                        width: "32px",
                        height: "48px",
                        position: "absolute",
                        top: "40px",
                        zIndex: 1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        right: 0,
                        borderTopLeftRadius: "24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transform: "scaleX(-1)",
                        transition: "250ms",
                    },
                    "@media screen and (max-width: 47.9375em)": {
                        "&:before, &:after": {
                            top: 0,
                            width: "24px",
                        },
                    },
                }}
            >
                <>
                    <MainEnvironment config={userEnvironmentsConfig.mainEnvironment}/>
                </>
            </TabView3>
        </Box>
    );
});

export default UserEnvironments;
